import { MaterialDetail } from '../../api/Params'
import { ActionType, CustomAction } from '../../global'

interface State {
  dataSource: MaterialDetail[]
}

export const initState: State = {
  dataSource: [],
}

type Action = ActionType<State>

const reducer = (state: State, action: CustomAction<Action>): State => {
  let newstate = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}
export default reducer

// 设置表格数据
export const setDataSourceAction = (
  param: MaterialDetail[],
): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 重载数据
export const reloadStateAction = (param: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: param,
})
import { MaterialDetail } from '../../api/Params'
import { ActionType, CustomAction } from '../../global'

interface State {
  dataSource: MaterialDetail[]
}

export const initState: State = {
  dataSource: [],
}

type Action = ActionType<State>

const reducer = (state: State, action: CustomAction<Action>): State => {
  let newstate = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}
export default reducer

// 设置表格数据
export const setDataSourceAction = (
  param: MaterialDetail[],
): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 重载数据
export const reloadStateAction = (param: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: param,
})
